var map = {
	"./curved_background.svg": 438
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model nonrecursive \.(svg|png|j(e)?pg)$
// module id = 323
// module chunks = 2 5